const appInfo = {
    title: 'SynerLab'
};
export default appInfo;

